var map = {
	"./about-curlture.png": 7539,
	"./about-history.png": 7843,
	"./ai-bg1.png": 368,
	"./ai-icon.png": 911,
	"./banner-1.png": 5651,
	"./banner-2.png": 1160,
	"./banner-3.png": 3873,
	"./banner-4.png": 782,
	"./banner-active.png": 1562,
	"./code-dy.png": 1574,
	"./code-sian.png": 8494,
	"./code-vxsp.png": 9460,
	"./code-wx.png": 4990,
	"./code-xhs.png": 7544,
	"./connect1.png": 1892,
	"./connect2.png": 4351,
	"./cro.png": 1965,
	"./default.png": 1836,
	"./dh-icon.png": 2573,
	"./flag.png": 1869,
	"./fzlc-bg.png": 842,
	"./home-des.png": 4921,
	"./honner-bg.png": 8189,
	"./hyjy.png": 4006,
	"./location1.png": 1013,
	"./location2.png": 2238,
	"./org-map.png": 5348,
	"./phone.png": 3351,
	"./solutuin-bg.png": 9906,
	"./tag-bg-1.png": 7669,
	"./tag-bg-2.png": 5870,
	"./tag-bg-3.png": 8887,
	"./tag-bg-4.png": 3720,
	"./tag-txt-1.png": 3090,
	"./tag-txt-2.png": 2825,
	"./tag-txt-3.png": 6576,
	"./tag-txt-4.png": 8799,
	"./tel.png": 2428,
	"./title-bg.png": 125,
	"./view-detial-bg.png": 7930,
	"./year-icon.png": 5980,
	"./zgyw-bg.png": 8076,
	"./zzgz-bg-1.png": 3588,
	"./zzgz-bg-2.png": 7151,
	"./zzgz-bg-3.png": 9062,
	"./zzgz-bg-4.png": 3321,
	"./zzgz-bg-5.png": 8496
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;